import {
  FieldType,
  VariableDataType,
} from '@client/graphql/__generated__/types';

export const FIELD_TO_VARIABLE_DATA_TYPE: Record<FieldType, VariableDataType> =
  {
    [FieldType.SELECT]: VariableDataType.LIST,
    [FieldType.CHECKBOX]: VariableDataType.BOOLEAN,
    [FieldType.DATE]: VariableDataType.TEXT,
    [FieldType.IMAGE]: VariableDataType.TEXT,
    [FieldType.INITIAL]: VariableDataType.TEXT,
    [FieldType.NUMBER]: VariableDataType.NUMBER,
    [FieldType.RADIO]: VariableDataType.BOOLEAN,
    [FieldType.SIGNATURE]: VariableDataType.TEXT,
    [FieldType.TEXT]: VariableDataType.TEXT,
    [FieldType.TEXTAREA]: VariableDataType.TEXT,
    [FieldType.SIGNED_DATE]: VariableDataType.TEXT,
  };

export const getVariableDataTypeForFieldType = (fieldType: FieldType) => {
  return FIELD_TO_VARIABLE_DATA_TYPE[fieldType] ?? VariableDataType.TEXT;
};
